export const concatBuffers = (buffers) => {
    if (buffers.length === 0) {
        return new Uint8Array(0);
    }
    const totalSize = buffers.reduce((sum, buffer) => sum + buffer.length, 0);
    const result = new Uint8Array(totalSize);
    let offset = 0;
    for (const buffer of buffers) {
        result.set(buffer, offset);
        offset += buffer.length;
    }
    return result;
};
